import { render, staticRenderFns } from "./Communicationresourceslist.vue?vue&type=template&id=cc2f84d2&"
import script from "./Communicationresourceslist.vue?vue&type=script&lang=js&"
export * from "./Communicationresourceslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports